export var Tags;
(function (Tags) {
    Tags["FrontLineWorkers"] = "front-line-workers";
    Tags["AdultsAndYoungPeople"] = "12-14,15-17,18+";
    Tags["YoungPeoples"] = "12-14,15-17";
    Tags["AdultAnd1517"] = "15-17,18+";
    Tags["AdultAnd1214"] = "12-14,18+";
    Tags["NA"] = "n/a";
    Tags["Unknown"] = "unknown";
})(Tags || (Tags = {}));
